import axios from 'axios';
import { store } from '../redux/storeConfig/store';
import { history } from '../history';
import { applicationActions } from '../new.redux/actions';

// API local: opcional REACT_APP_API_BASE_URL no .env.development.local (ex.: http://127.0.0.1:8000/api/).
// Sem variável, mantém api-v3.iuli.localhost (WAMP). Os REACT_APP_ENV abaixo continuam sobrescrevendo.
let baseURL =
  process.env.REACT_APP_API_BASE_URL || 'http://api-v3.iuli.localhost/api/';

// Não modificar (URL HMG)
if (process.env.REACT_APP_ENV === 'hmgv2') {
  baseURL = 'https://api-v2.hmg.iuli.com.br/api/';
}

// Não modificar (URL NEW HMG)
if (process.env.REACT_APP_ENV === 'hmgv3') {
  baseURL = 'https://api-v3.hmg.iuli.com.br/api/';
}


// Nova instância HMG (api.hml.iuli.com.br)
if (process.env.REACT_APP_ENV === 'hml') {
  baseURL = 'https://api.hml.iuli.com.br/api/';
}

// Não modificar (URL PROD.)
if (process.env.REACT_APP_ENV === 'prod') {
  baseURL = 'https://api-v2.iuli.com.br/api/';
}

export const API_HOST = baseURL;

const API = (
  apiOptions = {
    method: null,
    baseURL: null,
    headers: {
      Authorization: null,
    },
    params: null,
    body: null,
  }
) => {
  const state = store.getState();

  // Get locale from localStorage
  const locale = typeof window !== 'undefined' ? localStorage.getItem('iuli_locale') || 'pt' : 'pt';

  // Map frontend locale to backend locale
  const localeMap = {
    'pt': 'pt-br',
    'en': 'en',
    'es': 'es',
  };
  const backendLocale = localeMap[locale] || 'pt-br';

  const axiosConfig = {
    method: apiOptions.method || 'GET',
    baseURL: apiOptions.baseURL || API_HOST,
    headers: apiOptions.headers || {
      Authorization: state.auth?.login?.values?.accessToken
        ? `Bearer ${state.auth?.login?.values?.accessToken}`
        : null,
      'X-Locale': backendLocale,
    },
    params: apiOptions.params || {},
    ...(apiOptions.body && { body: apiOptions.body }),
  };

  // Create axios instance
  const instance = axios.create(axiosConfig);
  // Intercept 403 responses and redirect to welcome page
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 403 && error.response.data && error.response.data.message) {
        const errorMsg = error.response.data.message;

        let notificationMsg = null;
        switch (errorMsg) {
          case 'project_permission_error_on_transaction':
          case 'cost_center_permission_error_on_transaction':
            notificationMsg = 'Você não tem autorização para salvar transações deste Centro de Custo ou Projeto.';
            break;
          case 'project_permission_error_on_purchase':
          case 'cost_center_permission_error_on_purchase':
            notificationMsg = 'Você não tem autorização para aprovar compras deste Centro de Custo ou Projeto.';
            break;
          default:
            break;
        }

        if (notificationMsg) {
          store.dispatch(
            applicationActions.toggleDialog({
              type: 'error',
              title: 'Ops!',
              message: notificationMsg
            })
          );

          return Promise.reject(error);
        }
      } 
      
      if (error.response && error.response.status === 403) {
        history.push('/welcome');
      }

      return Promise.reject(error);
    }
  );
  return instance;
};

export default API;
